import React, { useState, useEffect } from 'react';
import API from '../http/API';
import {useNavigate, useLocation} from "react-router-dom";
import { useOrgState, useCourt, useRequestUrl, useForwardingOrg, useCaptchaKey } from '../context/contextHooks';
import { useStyles } from "../styles/styles";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from '@mui/material/useMediaQuery'
import { getSelectStates, parseSection } from "./homeFunctions";
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import HaveAgency from "./HaveAgency";
import Options from './Options';
import parse from "html-react-parser";

const CustomLandingPage = (props) => {
    const agencyId = props.agencyId;
    const [partyId, setPartyId] = useState(props.partyId);
    const courtId = props.court;
    const classes = useStyles;
    const theme = useTheme();
    const smallHeader = useMediaQuery(theme.breakpoints.down('lg'));
    const navigate = useNavigate();
    const location = useLocation();
    const [requestUrl,] = useRequestUrl();
    const [orgState, ] = useOrgState();
    const [forwardingOrg, setForwardingOrg] = useForwardingOrg();
    const [court, setCourt] = useCourt();
    const [captchaKey, setCaptchaKey] = useCaptchaKey();
    const [loading, setLoading] = useState(false);
    const [actionResponse, setActionResponse] = useState(null);
    const [orgs, setOrgs] = useState(null);
    const [selectedOrg, setSelectedOrg] = useState(null);
    const [courtStates, setCourtStates] = useState(null);
    const [agency, setAgency] = useState(agencyId);
    const [uiConfig, setUiConfig] = useState(null);

    const clearMessaging = () => {
        setActionResponse(null);
    }

    const getCourtStates = () => {
        clearMessaging();
        setLoading(true);
        const url = `${requestUrl}/getCourtStates`;
        API.getRetrieve(url, 'getCourtStates', null, setActionResponse);
    }


    const getOrgs = (state) => {
        clearMessaging();
        setSelectedOrg(null);
        if (state) {
            setLoading(true);
            if (!orgState || state !== orgState) {
                const url = `${requestUrl}/getOrgs/${state}`;
                API.getRetrieve(url, 'getOrgs', null, setActionResponse);
            } else {
                setOrgs(null);
            }
        }
    }

    const getAgency = (orgId) => {
        clearMessaging();
        setLoading(true);
        const url = `${requestUrl}/getOrgByLink/${orgId}`;
        API.getRetrieve(url, 'getOrg', null, setActionResponse);
    }
    const getCaptchaKey = () => {
        clearMessaging();
        setLoading(true);
        const url = `${requestUrl}/getCaptchaKey`;
        API.getRetrieve(url, 'getCaptchaKey', null, setActionResponse);
    }

    const showNext = (destination) => {
        if (destination) {
            if (destination.key === 'balances') {
                navigate('/balanceLookup');
            } else if (destination.key === 'miscFees') {
                navigate('/miscFees');
            }
        } else {
            setActionResponse({error: true, errorMessage: 'No payment type has been selected'});
        }
    }


    useEffect(() => {
        if (!loading && !courtStates) {
            getCourtStates();
        }
    }, [courtStates, loading])

    useEffect(() => {
        if (!loading && !captchaKey && (!actionResponse || !actionResponse.error)) {
            getCaptchaKey();
        }
    }, [captchaKey, loading])
    useEffect(() => {
        if (court) {
            setUiConfig(court.landingPageConfig);
            document.title = 'Neumo Payments - Online Citation and Court Payment Portal';
        } else {
            setUiConfig(null);
            document.title = 'Neumo Payments - Online Citation and Court Payment Portal';
        }
    }, [court])

    useEffect(() => {
        if (!loading && courtId && partyId) {
            if (!court) {
                getAgency(courtId);
            } else {
                const url = '/balanceLookup';
                const state = {courtId, partyId};
                navigate(url, {replace: false, state});
                setPartyId(null);
            }
        }
    }, [courtId, partyId, court, loading]);

    useEffect(() => {
        setCourt(selectedOrg);
    }, [selectedOrg])

    useEffect(() => {
        if (agency && courtStates) {
            getAgency(agency);
        }
    }, [agency, courtStates])

    useEffect(() => {
        if (forwardingOrg) {
            setSelectedOrg(forwardingOrg);
        }
    }, [forwardingOrg])

    useEffect(() => {
        if (location.state && location.state.court && !forwardingOrg) {
        }
    }, [location])

    useEffect(() => {
        if (loading && actionResponse) {
            if (!actionResponse.error) {
                if (actionResponse.requestType === 'getOrgs' && actionResponse.data) {
                    setOrgs(actionResponse.data);
                } else if (actionResponse.requestType === 'getCourtStates') {
                    setCourtStates(getSelectStates(actionResponse.data));
                } else if (actionResponse.requestType === 'getOrg') {
                    if (actionResponse.data) {
                        setSelectedOrg(actionResponse.data);
                        setForwardingOrg(actionResponse.data);
                    } else {
                        setAgency(null);
                    }
                } else if (actionResponse.requestType === 'getCaptchaKey') {
                    setCaptchaKey(actionResponse.data);
                }
            }
            setLoading(false);
        }
    }, [loading, actionResponse])

    return (
        <>
            <Typography variant={smallHeader ? 'h5' : 'h4'} component="h1" color='primary' sx={{...classes.title, marginTop: '1rem'}}>
                {uiConfig && uiConfig.title ? parse(uiConfig.title):''}
            </Typography>
            <Grid
                container
                spacing={3}
                sx={{
                    justifyContent: "center",
                    marginTop: '1rem'
                }}>
                <Box
                    component={Grid}
                    size={{xs: 12, sm: 6, md: 5}}
                    style={{paddingTop: '0'}}
                    sx={{
                        justifyItems: 'center',
                        display: {xs: 'none', sm: 'block'}
                    }}>
                    <Typography
                        variant={smallHeader ? 'subtitle2' : 'subtitle1'}
                        component="div"
                        sx={{
                            fontSize: smallHeader ? '' : '1.2rem',
                            lineHeight: smallHeader ? '1.2rem' : '1.4rem'
                        }}
                    >
                        {uiConfig && uiConfig.leftSection ? parseSection(uiConfig.leftSection) : ''}
                    </Typography>
                </Box>
                <Grid
                    sx={classes.gridBottom}
                    style={{paddingTop: '0'}}
                    size={{
                        xs: 12,
                        sm: 6,
                        md: 7
                    }}>
                    {actionResponse && actionResponse.error &&
                        <Alert severity='error'>
                            <AlertTitle>Error</AlertTitle>
                            {actionResponse.errorMessage}
                        </Alert>
                    }
                    <Stack>
                        { (agency || forwardingOrg) ?
                            <HaveAgency selectedOrg={forwardingOrg ? forwardingOrg : selectedOrg} setSelectedOrg={setSelectedOrg} setAgency={setAgency} showNext={showNext} /> :
                            <Options
                                courtStates={courtStates}
                                getOrgs={getOrgs}
                                orgs={orgs}
                                court={court}
                                setSelectedOrg={setSelectedOrg}
                                showNext={showNext}
                                setActionResponse={setActionResponse}
                            />
                        }
                        <Typography
                            variant={smallHeader ? 'subtitle2' : 'subtitle1'}
                            component="div"
                            sx={{
                                fontSize: smallHeader ? '' : '1.2rem',
                                lineHeight: smallHeader ? '1.2rem' : '1.4rem',
                                textAlign: 'left',
                                marginTop: '1.5rem'
                            }}
                        >
                            {uiConfig && uiConfig.bottomRightSection ? parseSection(uiConfig.bottomRightSection) : ''}
                        </Typography>
                    </Stack>
                </Grid>
            </Grid>
        </>
    );
}

export default CustomLandingPage;
